import type { BaseCategory } from "@usercentrics/cmp-browser-sdk";

/** Essential categories first, otherwise the configured order is preserved. */
export function orderCategories(categories: BaseCategory[]): BaseCategory[] {
  return [...categories].sort(
    (a, b) => Number(b.isEssential) - Number(a.isEssential),
  );
}

/**
 * A category is "on" when every one of its selectable (non-essential) services is granted.
 * Categories with only essential services are always considered enabled.
 */
export function isCategoryEnabled(
  category: BaseCategory,
  serviceConsents: Record<string, boolean>,
): boolean {
  const selectable = category.services.filter(
    (service) => !service.isEssential,
  );
  if (selectable.length === 0) {
    return true;
  }
  return selectable.every((service) => serviceConsents[service.id]);
}
